import React from 'react';

import HeaderContainer from 'containers/common/WowHeaderContainer';
import Footer from 'components/common/WowFooter';
// import LayerPopupContainer from 'containers/common/LayerPopupContainer';

import styles from './PageTemplateWow.scss';
import classNames from 'classnames/bind';
// import Footer from 'components/common/Footer';

const cx = classNames.bind(styles);

const PageTemplate = ({children}) => (
  <div className={cx('page-template')}>
    <HeaderContainer/>
    <div className={cx('main')}>
      {children}
    </div>
    <Footer/>
  
    {/* <LayerPopupContainer/> */}
  </div>
);

export default PageTemplate;